import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import Footer from "../Components/Footer";
import ReviewSlider from "../Components/ReviewSlider";
import Header from "../Components/Header";
import BlogCarts from "../Components/blogcarts";
import { getData } from "../Api";

const ArticleCard = () => {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        const response = await getData(`/blog/${slug}`);
        setArticle(response.data);
      } catch (error) {
        console.error("Error fetching article:", error);
      }
    };

    fetchArticle();
  }, [slug]);

  if (!article) return <p>Loading...</p>;



  return (
    <>
      <main className="container-fluid">
        <Header />
        <div className="row pagebgimg py-3" style={{ backgroundImage: "url('assets/img/Breadcrumbs Banner (1).png')" }}>
          <h2 className="text-center text-success fw-bold">{article.title}</h2>
        </div>

        <div className="row justify-content-center py-5">
          <div className="col-xl-8 col-lg-9 col-md-10 col-sm-12">
            <div className="article-header text-center">
              <img
                src={`${article.image}`}
                className="article-img  rounded"
                alt={article.title}/>
            </div>
            <div>
              <h2 className="mt-3 mb-4">{article.title}</h2>
              <p className="article-meta" >
                <i className="bi bi-person-circle"></i> {article.writer || "Rajasthani Aachar"}
                <i className="bi bi-calendar-event ms-3"></i> {new Date(article.created_at).toDateString()}
                
              </p>
            </div>
            <hr />
            <BlogCarts slug={article.product_slug} />
            <div className="py-3" dangerouslySetInnerHTML={{ __html: article.description }}></div>

            <BlogCarts slug={article.product_slug} />
          </div>
        </div>
        <section className="hero-section row align-items-center my-5">
        {/* Left Panel */}

        <div className="col-md-12  left-panel  text-center">
          <ReviewSlider />
        </div>

        {/* Right Panel */}
        {/* <div className="col-md-6 right-panel p-sm-5">
          <div className="hero__media hero__media--16105224605606f7b5 desttopview desktop_hero_media">
            <video
              loading="lazy"
              loop
              muted
              autoPlay
              onCanPlay={(e) => e.target.play()}
              onLoadedMetadata={(e) => (e.target.muted = true)}
            >
              <source src="assets/video/desktop-video.mp4" type="video/mp4" />
            </video>
          </div>
        </div> */}
      </section>
        <Footer />
      </main>
    </>
  );
};

export default ArticleCard;
